export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives5.10f9f941.jpg";